import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Layout() {
  const { user, logout } = useAuth();
  const location = useLocation();

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4">
          <div className="flex justify-between items-center">
            <Link to="/" className="text-2xl font-bold">
              <span className="text-yellow-300">Studenten</span>City
            </Link>
            <div className="hidden md:flex space-x-6 items-center">
              <Link to="/events" className="hover:text-yellow-300 transition">Evenementen</Link>
              <Link to="/rooms" className="hover:text-yellow-300 transition">Kamers</Link>
              <Link to="/discounts" className="hover:text-yellow-300 transition">Kortingen</Link>
              <Link to="/blog" className="hover:text-yellow-300 transition">Blog</Link>
              {user ? (
                <>
                  <Link to="/dashboard" className="hover:text-yellow-300 transition">Dashboard</Link>
                  <button onClick={logout} className="bg-white text-blue-600 px-4 py-2 rounded-full font-semibold hover:bg-yellow-300 hover:text-blue-800 transition">
                    Uitloggen
                  </button>
                </>
              ) : (
                <Link to="/login" className="bg-white text-blue-600 px-4 py-2 rounded-full font-semibold hover:bg-yellow-300 hover:text-blue-800 transition">
                  Inloggen
                </Link>
              )}
            </div>
          </div>
        </div>
      </nav>
      <main>
        <Outlet />
      </main>
      <footer className="bg-gray-900 text-white py-12 mt-20">
        <div className="container mx-auto px-4 text-center">
          <p className="text-xl font-bold mb-4">StudentenCity</p>
          <p className="text-gray-400">© 2026 StudentenCity. Alle rechten voorbehouden.</p>
        </div>
      </footer>
    </div>
  );
}
